module.exports = __webpack_public_path__ + "media/images/lenovologo-pos-red-530c16bd4e1eae3f72ebffad7ab5f346.png";